import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackInitiateCheckout } from '../../utils/metaPixel';
export function FinalCTA() {
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-52" data-mp="3mti8ejiju3vn">
      <div className="mx-auto max-w-2xl px-6 text-center sm:px-8" data-id="element-53" data-mp="3rsbq6o4vch1m">
        <h2 className="font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-54" data-mp="3rqihz4elxori">
          La decisión es tuya.
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-left text-base leading-relaxed text-gris-texto sm:text-center" data-id="element-55" data-mp="3hvqhnstn4nt1">
          <p data-id="element-56" data-mp="33wh4l20qe9ta">
            Puedes seguir como hasta ahora. Preparando entrenamientos desde cero cada semana, improvisando
            cuando el plan falla y llegando a la pista con la duda de si lo que vas a hacer es lo correcto
            para tu equipo.
          </p>
          <p data-id="element-57" data-mp="172vylqxtsoax">
            O puedes llegar al martes con todo listo. Con la sesión elegida, el objetivo claro y la
            corrección exacta en el bolsillo.
          </p>
          <p className="font-semibold text-marino" data-id="element-58" data-mp="l9seiscsa315">Sesiones listas. 6 tomos. 5 bonos. 7 días de garantía.</p>
          <p className="text-naranja" data-id="element-59" data-mp="z1gpgsbaqlgj">El precio de una cena. El valor de una temporada entera.</p>
        </div>

        <m.a href={CHECKOUT_URL} onClick={trackInitiateCheckout} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="group mx-auto mt-8 flex max-w-sm flex-col items-center gap-3 rounded-2xl border-2 border-naranja bg-white p-6 text-center shadow-leve transition-colors hover:border-naranja/70" data-id="element-60" data-mp="uz3mgbnxp1ng">
          <span className="font-heading text-sm font-semibold uppercase tracking-wide text-gris-muted" data-id="element-61" data-mp="bdpept5emghd">
            🏐 Balonmano Pro 360: La Pizarra del Entrenador
          </span>
          <span className="font-heading text-3xl font-bold text-marino" data-id="element-62" data-mp="1mq9nqvfe55eb">19€</span>
          <span className="mt-2 inline-flex items-center gap-2 rounded-xl bg-marino px-6 py-3 text-sm font-semibold uppercase text-white transition-colors group-hover:bg-marino-dark" data-id="element-63" data-mp="kcln2q5yh1yt">
            Quiero Balonmano Pro 360
            <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-64" data-mp="tbp4zqtdzbbq" />
          </span>
          <span className="text-[11px] text-gris-muted" data-id="element-65" data-mp="1mm1wed8k70o">💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 7 días</span>
        </m.a>
      </div>
    </section>;
}